export default "__VITE_ASSET__2238f9a3__"